import api from "./api";

// Chave da coluna = Tarefa.status. Agora é dinâmica (kanban editável).
export type StatusKanban = string;

export interface ColunaCustom {
  status: string;
  label: string;
  cor: string;
  emoji: string;
}

/**
 * Fallback usado só se o catálogo global de colunas ainda não carregou.
 */
export const COLUNAS_DEFAULT: ColunaCustom[] = [
  { status: "a_fazer", label: "A fazer", cor: "#94a3b8", emoji: "" },
  { status: "em_andamento", label: "Em andamento", cor: "#3b82f6", emoji: "" },
  { status: "concluido", label: "Finalizados", cor: "#10b981", emoji: "" },
];

/**
 * Mescla a customização por-projeto (label/cor/emoji) sobre a lista BASE de
 * colunas (o catálogo global, já ordenado). Mantém a ordem da base.
 */
export function mesclarColunasComBase(base: ColunaCustom[], customs: ColunaCustom[]): ColunaCustom[] {
  return base.map((d) => {
    const c = customs.find((x) => x.status === d.status);
    return c && c.label ? { ...d, ...c } : d;
  });
}

export async function listarColunasProjeto(projetoId: string) {
  const r = await api.get(`/projetos/${projetoId}/colunas`);
  return r.data.data as ColunaCustom[];
}

export async function salvarColunasProjeto(projetoId: string, colunas: ColunaCustom[]) {
  const r = await api.put(`/projetos/${projetoId}/colunas`, { colunas });
  return r.data.data as ColunaCustom[];
}

export async function restaurarColunasProjeto(projetoId: string) {
  await api.delete(`/projetos/${projetoId}/colunas`);
}
